//Smooth scroll
import SmoothScroll from 'smooth-scroll';

var scroll = new SmoothScroll('a[href*="#"]', {
	speed: 700,
	speedAsDuration: true
});